import { redux_store } from "../../../store";
import { API } from "../../api";
async function update_user_address(data) {
    const state = redux_store.getState();
    const userState = state.userState;
    return await new API().apiPut({
        baseUrl: process.env.LETS_TRADE_USER_URL ?? "",
        endpoint: `v2/update/address`,
        content: data,
        authorization: userState.user.token,
    });
}
export { update_user_address };
